let $openingHoursPreview;

/**
 * Sets the current opening hours information for the mall
 *
 * @param {Object} opening_hours - Contains information about current day and weekly hours
 */
export function machSetCurrentOpeningHours(opening_hours) {
    $openingHoursPreview = jQuery(".hours-header-preview");
    if (opening_hours.current) {
        let currentDay = opening_hours.current;
        let weekHtmlRender = opening_hours.week;

        // Check if the mall is currently open based on America/New_York timezone
        let isOpen = false;

        if (!currentDay.is_closed) {
            if (currentDay.is_24h) {
                isOpen = true;
            } else if (currentDay.opening_hour && currentDay.closing_hours) {
                const now = new Date();
                const currentDayString = now.toLocaleString("en-US", { timeZone: "America/Toronto" });
                const currentTime = new Date(currentDayString);

                const today = new Date(currentTime);
                today.setHours(0, 0, 0, 0);

                const [openHour, openMinute] = currentDay.opening_hour.split(":").map(Number);
                const openingTime = new Date(today);
                openingTime.setHours(openHour, openMinute, 0, 0);

                const [closeHour, closeMinute] = currentDay.closing_hours.split(":").map(Number);
                const closingTime = new Date(today);
                closingTime.setHours(closeHour, closeMinute, 0, 0);

                // Compare current time with opening and closing times
                isOpen = currentTime >= openingTime && currentTime < closingTime;
            }
        }

        // Update the status string based on whether the mall is open (in French with translation support)
        // Vérifie si les clés 'open' et 'closed' existent dans backendInfo.labels, sinon utilise "Ouvert" ou "Fermé"
        currentDay.status_string = isOpen
            ? backendInfo.labels
                ? backendInfo.labels.open
                : "Ouvert"
            : backendInfo.labels
            ? backendInfo.labels.closed
            : "Fermé";

        $openingHoursPreview.find(".open-status-hours .current").text(`${currentDay.status_string} / ${currentDay.opening_hour} - ${currentDay.closing_hours}`);
        $openingHoursPreview.find(".detailed-hours").html(weekHtmlRender);
        $openingHoursPreview.find(".open-status-loading").addClass("hidden");
        $openingHoursPreview.find(".open-status-hours").removeClass("hidden");
    }
}
